<template>
  <div class="million-read-user-center-block-title">
    {{ title }}<template v-if="count !== 0">·{{ count }}</template>
  </div>
</template>

<script>
  export default {
    name: 'MillionReadUserCenterBlockTitle',
    props: {
      title: {
        type: String,
        required: true,
      },
      count: {
        type: Number,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .million-read-user-center-block-title {
    box-sizing: border-box;
    margin-bottom: @size-medium;
    padding-left: @size-base;
    color: @color-text-base;
    font-size: @font-size-large;
    font-weight: @font-weight-strong;
    line-height: 1;
  }

</style>
